// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AddonAutofillController from "./addon_autofill_controller"
application.register("addon-autofill", AddonAutofillController)

import AppointmentDurationController from "./appointment_duration_controller"
application.register("appointment-duration", AppointmentDurationController)

import AuthFlowController from "./auth_flow_controller"
application.register("auth-flow", AuthFlowController)

import BulkScheduleController from "./bulk_schedule_controller"
application.register("bulk-schedule", BulkScheduleController)

import BookingAddonsController from "./booking_addons_controller"
application.register("booking-addons", BookingAddonsController)

import BookingCalendarController from "./booking_calendar_controller"
application.register("booking-calendar", BookingCalendarController)

import CalendarInteractionController from "./calendar_interaction_controller"
application.register("calendar-interaction", CalendarInteractionController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ContactUpdateController from "./contact_update_controller"
application.register("contact-update", ContactUpdateController)

import CustomerAutofillController from "./customer_autofill_controller"
application.register("customer-autofill", CustomerAutofillController)

import CustomerCreationController from "./customer_creation_controller"
application.register("customer-creation", CustomerCreationController)

import DepositToggleController from "./deposit_toggle_controller"
application.register("deposit-toggle", DepositToggleController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import EmployeeFilterController from "./employee_filter_controller"
application.register("employee-filter", EmployeeFilterController)

import EmployeePreselectController from "./employee_preselect_controller"
application.register("employee-preselect", EmployeePreselectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileScheduleController from "./mobile_schedule_controller"
application.register("mobile-schedule", MobileScheduleController)

import NipLookupController from "./nip_lookup_controller"
application.register("nip-lookup", NipLookupController)

import ServiceAddonsController from "./service_addons_controller"
application.register("service-addons", ServiceAddonsController)

import ServiceCopyController from "./service_copy_controller"
application.register("service-copy", ServiceCopyController)

import SubscriptionController from "./subscription_controller"
application.register("subscription", SubscriptionController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimezoneDetectorController from "./timezone_detector_controller"
application.register("timezone-detector", TimezoneDetectorController)
